import { logWithPrefix } from "@/plugins/logging";
// import dniPattern from '~/utils/dniPattern'
import Vue from "vue";
const log = logWithPrefix("[plugin/directive.js]");

Vue.directive("load-help", {
  bind(el, binding) {
    el.addEventListener("click", function () {
      const refs = binding.value.refs;
      const tag = binding.value.tag;
      log(refs.help);
      if (refs.help) {
        refs.help.jumpTohelp(tag);
      } else {
        log("Failed to get $refs.help");
      }
    });
  },
  inserted(el) {
    if (!el.className.includes("el-form-item__label")) {
      el.className += " el-form-item__label";
    }
    if (!el.className.includes("link-label")) {
      el.className += " link-label";
    }
  },
});
Vue.directive("jump-to", {
  bind(el, binding) {
    el.addEventListener("click", function () {
      const path = binding.value;
      log(Vue, path);
    });
  },
});

const inputLimitInput = (el, binding, vnode) => {
  const type = binding.value;
  const expression = vnode.data.model.expression;
  if (!expression) {
    return;
  }
  const expressionArr = expression.split(".");
  const name = expressionArr[expressionArr.length - 1];
  let target = vnode.context;
  for (let i = 0; i < expressionArr.length - 1; i++) {
    target = target[expressionArr[i]];
  }
  const value = target[name];
  if (type === "num") {
    target[name] = value.replace(/\D+/, "");
  } else if (type === "mac") {
    const valueUpper = value.toUpperCase();
    const valLen = valueUpper.length;
    let newVal = "";
    let newLen = 0;

    // Auto add ':'
    for (let i = 0; i < valLen && i < 17; i++) {
      if (/[0-9A-F]/.test(valueUpper.charAt(i))) {
        newVal += valueUpper.charAt(i);
        newLen++;
        if (newLen >= 12) {
          break;
        }
        if (newLen > 0 && newLen % 2 === 0 && i !== valLen - 1) {
          newVal += ":";
        }
      }
    }
    target[name] = newVal;
  } else if (type == "dhcpOptions") {
    const reg = /([a-zA-Z0-9\-\.]*)/g;
    const match = reg.exec(value);
    log(match);
    target[name] = match ? match[0] : "";
  } else if (type == "printable") {
    const reg = /([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]*)/g;
    const match = reg.exec(value);
    log(match);
    target[name] = match ? match[0] : "";
  } else if (type === "sn") {
    target[name] = value.replace(/[^0-9A-Za-z]+/, "");
  }
};
Vue.directive("limit", {
  bind(el, binding, vnode) {
    el.addEventListener("input", function () {
      inputLimitInput(el, binding, vnode);
    });
    el.addEventListener("change", function () {
      inputLimitInput(el, binding, vnode);
    });
    el.addEventListener("keyup", function () {
      inputLimitInput(el, binding, vnode);
    });
    el.addEventListener("mouseup", function () {
      inputLimitInput(el, binding, vnode);
    });
  },
});

Vue.directive("dni-focus", {
  bind(el) {
    const tag = el.querySelectorAll("input")[0];
    const label = el.querySelectorAll("label")[0];
    if (!tag) {
      return;
    }
    tag.addEventListener("change", function () {
      if (tag.value !== "") {
        const classes = label.className.split(" ");
        classes.push("static-focus");
        label.className = classes.join(" ");
      } else {
        label.className = label.className.replace(/static-focus/g, "");
      }
    });
    tag.addEventListener("focus", function () {
      const classes = label.className.split(" ");
      classes.push("focus");
      label.className = classes.join(" ");
    });
    tag.addEventListener("blur", function () {
      const classNames = label.className.split(" ").filter((e) => {
        return e != "focus";
      });
      label.className = classNames.join(" ");
      if (tag.value !== "") {
        const classes = label.className.split(" ");
        classes.push("static-focus");
        label.className = classes.join(" ");
      } else {
        label.className = label.className.replace(/static-focus/g, "");
      }
    });
  },
});

// Vue.directive('test', {
//   bind(el, binding, vnode, oldVnode) {
//     // 当指令绑定到 HTML 元素上时触发.**只调用一次**
//     log('0 bind triggerd', binding.value);
//   },
//   // 当被绑定的元素插入到 DOM 中时……
//   inserted(el, binding, vnode, oldVnode) {
//     log('1 inserted triggerd', binding.value);
//   },
//   updated(el, binding, vnode, oldVnode) {
//     // 所在组件的`VNode`更新时调用.
//     log('2 updated triggerd', binding.value);
//   },
//   componentUpdated(el, binding, vnode, oldVnode) {
//     // 指令所在组件的 VNode 及其子 VNode 全部更新后调用。
//     log('3 componentUpdated triggerd', binding.value);
//   },
//   unbind(el, binding, vnode, oldVnode) {
//     // 只调用一次，指令与元素解绑时调用.
//     log('4 unbind triggerd', binding.value);
//   },
// });
